import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import PublicInfoList from "../../components/publicInfo-list/PublicInfoList";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import {usePublicInformationController} from "../../controllers/publicInfo-controller";
import {useAuth} from "../../context/authContext";
import AddPublicInformationModal from "./components/create-modal";
import React, {useEffect} from "react";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less";

const PublicInformationPage = () => {

  const publicInformationController = usePublicInformationController()
  const {
    toggleModal,
    isModalOpen,
    fetchPublicInfoItemsList,
    lastUpdate,
  } = publicInformationController
  const {canManageContent} = useAuth()

  useEffect(() => {
    fetchPublicInfoItemsList([])
  }, [lastUpdate])

  const headerActions = <>{canManageContent && <AddActionButton onClick={toggleModal}/>}</>
  return (
    <>
      <div className="page_title">
        <PageHeader
          title={
            <div className="page-header_title">
              <div className="page_name">
                Публічна інформація
              </div>
            </div>
          }
          extra={headerActions}
          onBack={navigateBackHandler}
        />
      </div>
      <div className="page_content public-information-page">
        <PublicInfoList publicInfoController={publicInformationController}/>
      </div>
      {isModalOpen && <AddPublicInformationModal publicInfoController={publicInformationController}/>}
      <ScrollToTopButton elementSelector={".page_content"}/>
    </>
  )

}

export default PublicInformationPage
